import api from "./axios";

export async function createBusiness(payload) {
  const { data } = await api.post("/Business", payload);
  return data;
}

export async function updateBusinessSettings(businessId, payload) {
  const { data } = await api.put(`/Business/${businessId}/settings`, payload);
  return data;
}

export async function getBusinesses() {
  const { data } = await api.get("/Business");
  return data;
}

export async function getBusinessSettings(businessId) {
  const { data } = await api.get(`/Business/${businessId}/settings`);
  return data;
}

export async function getBusinessReviews(businessId) {
  const { data } = await api.get(`/Reviews/business/${businessId}`);
  return data;
}

export async function getPendingReviews(businessId) {
  const { data } = await api.get(`/Reviews/pending/${businessId}`);
  return data;
}
